import styled from 'styled-components';
import { rem } from 'polished';
import { gray } from '@whitelabel/helpers/style/colors';

const StyledNavLine = styled.div`
  position: static;
  width: 100%;
  height: ${rem(2)};
  background-color: ${gray(700)};
`;

export default StyledNavLine;
